export enum ExternalLinksEnum {
	NONE = "NONE",
	CHARISMA = "CHARISMA",
	OOB = "OOB",
	CHARISMA_OOB = "CHARISMA_OOB",
}
